// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Xxjy","rootNoMargin":"styles_rootNoMargin__2QT-r"};